import api from "@/lib/api";

export interface PostContractRequest {
  transactionId: string;
}

export interface PostContractResponse {
  contractNumber: string;
  status: string;
  messageType: string;
  errorCode: string;
  returnUrl: string;
}

export default {
  // PAYセール対応の契約登録 API
  postContractSale(data: any) {
    return api<PostContractRequest, PostContractResponse>({
      endpoint: "sale/web-api/contract",
      method: "POST",
      body: data
    });
  }
};
